/* thead.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./thead.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
var baseStyles = null;

/**
 * __THead__
 *
 * A primitive table head container. Applies the HTML native element with minimal styling.
 *
 * @primitive
 */
export var THead = function THead(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement("thead", {
    className: ax(["_1r04idpf _19itglyw _179r66cm _mqm2ixv9 _kqsw1if8 _1pbykb7n _bfhkvuon"]),
    style: {
      "--_15oo9n7": ix("var(--ds-border-width-selected, 2px)".concat(" solid ", "var(--ds-border, #eee)")),
      "--_td4d7n": ix("var(--ds-border-width-selected, 2px)".concat(" solid transparent"))
    }
  }, children);
};